"use client";

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const DEFAULT_PANEL_STYLE = {
  border: "1px solid #6ED828",
  background:
    "linear-gradient(105deg, rgba(217, 217, 217, 0.12) -2.98%, rgba(115, 115, 115, 0.06) 97.56%)",
  backdropFilter: "blur(10.8px)",
  WebkitBackdropFilter: "blur(10.8px)",
};

export default function ModalWrapper({
  isOpen,
  onClose,
  children,
  panelClassName = "max-w-md",
  panelStyle,
  overlayClassName = "bg-black/85",
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen || !mounted) return null;

  return createPortal(
    <div className="fixed inset-0 z-[1000]">
      {/* Scrim — sibling of scroll layer so backdrop-filter on panel can sample page content */}
      <button
        type="button"
        className={`absolute inset-0 ${overlayClassName}`}
        onClick={onClose}
        aria-label="Close modal"
      />

      {/* Scroll/center layer — overflow isolated from panel blur */}
      <div className="absolute inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 md:p-6">
          <div
            className={`relative w-full rounded-2xl p-6 shadow-lg ${panelClassName}`}
            onClick={(e) => e.stopPropagation()}
            style={{ ...DEFAULT_PANEL_STYLE, ...panelStyle }}
          >
            <button
              type="button"
              onClick={onClose}
              className="absolute top-3 right-3 z-10 flex size-8 items-center justify-center rounded-full text-xl text-white/70 transition hover:bg-white/20 hover:text-white"
              aria-label="Close"
            >
              ✕
            </button>

            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
